import { Box, ButtonBase, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function Item({ id, title, description, active = false }) {
  const navigate = useNavigate();

  return (
    <ButtonBase
      sx={{
        p: 2,
        textAlign: 'start',
        bgcolor: active ? 'lightgray' : 'inherit',
      }}
      onClick={() => navigate(`#${id}`)}
    >
      <Box width="100%">
        <Typography variant="body1" fontWeight="bold">
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {description}
        </Typography>
      </Box>
    </ButtonBase>
  );
}
